import ComboboxWrapper from "components/list/combobox-wrapper-with-api";
import { BREIFCASE, USER } from "icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";
import { Icon } from "components";
import { CIRCLE } from "icons";
import { RenderProfile } from "components/render-profile";
import { formatName } from "utils";
import { fetchJobsForTimesheetReview } from "../api";
import { fetchEmployeesOfJobs } from "../review/api";

export function TimesheetDayFilters({ filters, setFilters }) {
  const reviewOptions = [
    { label: "All", value: undefined },
    { label: "Reviewed", value: false },
    { label: "Unreviewed", value: true },
  ];

  const handleReviewStatusChange = (value) => {
    let newFilters = { ...filters };

    newFilters._unreviewed_hours = {
      _eq: value,
    };

    if (value === true) {
      newFilters.logged_hours = { _gt: 0 };
      newFilters.approved_hours = { _null: true };
      newFilters.unapproved_hours = { _null: true };
    } else if (value === false) {
      newFilters.logged_hours = { _gt: 0 };
      newFilters.approved_hours = { _nnull: true };
      newFilters.unapproved_hours = { _nnull: true };
    } else {
      newFilters._unreviewed_hours = undefined;
      newFilters.logged_hours = undefined;
      newFilters.approved_hours = undefined;
      newFilters.unapproved_hours = undefined;
    }

    setFilters(newFilters);
  };

  return (
    <div className="flex gap-4" key={filters?._unreviewed_hours}>
      <Select
        onValueChange={handleReviewStatusChange}
        value={filters?._unreviewed_hours?._eq}
      >
        <SelectTrigger className="w-40">
          <div className="flex items-center">
            <Icon icon={CIRCLE} className="mr-2" /> <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {reviewOptions.map((opt) => (
            <SelectItem key={opt.value} value={opt?.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <ComboboxWrapper
        filterKey="job"
        filters={filters}
        fetchFn={fetchJobsForTimesheetReview}
        valueKey="id"
        className="w-60"
        labelKey={["projectName", "name"]}
        labelJoinKey=": "
        placeholder="Select Project"
        searchPlaceholder="Search Project or Job..."
        onChange={(selectedItem) =>
          setFilters({
            ...filters,
            job: {
              id: { _eq: selectedItem?.value },
              __selectedItem: selectedItem,
            },
          })
        }
        icon={BREIFCASE}
      />

      <ComboboxWrapper
        filterKey="employee"
        filters={filters}
        fetchFn={(search) => fetchEmployeesOfJobs(search, filters?.job?.id?._eq)}
        valueKey="id"
        className="w-60"
        transformer={(item) => {
          return {
            label: <RenderProfile user={item} />,
            select: formatName(item),
            value: item.id,
          };
        }}
        placeholder="Select Employee"
        searchPlaceholder="Search employee..."
        dependsOn={filters?.job?.id?._eq}
        onChange={(selectedItem) =>
          setFilters({
            ...filters,
            employee: {
              _eq: selectedItem?.value,
              __selectedItem: selectedItem,
            },
          })
        }
        icon={USER}
      />
      {/* <TimesheetSelect
        placeholder="Select Project"
        value={filters?.project?._eq}
        onValueChange={(selectedItem) =>
          setFilters({
            ...filters,
            employee: {
              _eq: selectedItem.value,
              __selectedItems: selectedItem,
            },
          })
        }
        items={data}
      />
      <TimesheetSelect
        placeholder="Select Employee"
        value={filters?.project?._eq}
        onValueChange={(selectedItem) =>
          setFilters({
            ...filters,
            employee: {
              _eq: selectedItem.value,
              __selectedItems: selectedItem,
            },
          })
        }
        items={data}
      /> */}
    </div>
  );
}
